import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { JobPositionsService } from "../../job-positions.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "../../../../auth/service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-view",
  templateUrl: "./view-job-positions.component.html",
  styleUrls: ["./view-job-positions.component.scss"],
})
export class ViewJobPositionsComponent implements OnInit {
  public contentHeader: IContentHeader;
  public currentId: number = null;
  public activeTab: string = "detail";
  public currentJobPosition: any = null;
  public searchKeyword: string = "";
  public candidateList: any[] = [];
  public filteredCandidateList: any[] = [];

  constructor(
    private _jobPositionService: JobPositionsService,
    private activatedRoute: ActivatedRoute,
    private _router: Router,
    private _changeDetectorRef: ChangeDetectorRef,
    public _authenticationService: AuthenticationService,
    public _utilService: UtilsService,
  ) {
    this.activatedRoute.params.subscribe(async (params) => {
      if (params.hasOwnProperty("id")) {
        this.currentId = Number(params.id);
      }
    });
  }
  async ngOnInit() {
    if (!this._authenticationService.hasCapability("view_job_position")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.currentJobPosition = await this._jobPositionService.getJobPosition(this.currentId);
    if (!this.currentJobPosition) {
      await this._router.navigateByUrl("/dashboard/main");
      await this._utilService.showToastrError("ERROR_NOT_FOUND_JOB_POSITION");
      return false;
    }
    this.candidateList = this.currentJobPosition.candidates;
    this.contentHeader = {
      headerTitle: this.currentJobPosition.title ? this.currentJobPosition.title : "-",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.JOB_POSITIONS",
            isLink: true,
            link: "/dashboard/job-positions",
          },
          {
            name: this.currentJobPosition.title ? this.currentJobPosition.title : "-",
            isLink: false,
          },
        ],
      },
    };

    this.filterList();
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
    this._changeDetectorRef.detectChanges();
  }
  filterList() {
    let items: any[] = this.candidateList;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = this.candidateList.filter((item: any) => item.firstname.toLowerCase().includes(this.searchKeyword) || item?.lastname?.toLowerCase().includes(this.searchKeyword));
    }

    this.filteredCandidateList = items;
  }

  async transformToCandidate(candidate: any) {
    if (!this._authenticationService.hasCapability("create_candidate")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this._router.navigate([`/dashboard/candidate/add`], { queryParams: { proposedCandidate: JSON.stringify(candidate) } });
  }
}
